import {
  CandleFetchParams,
  CandlePoint,
  ExchangeCandleRestAdapter,
} from "../../candle.types";
import { toGateInterval } from "../../candle-intervals";
import { normalizeCandleSymbol } from "../../candle-symbols";
import { dedupeCandles } from "./rest-adapter.utils";

interface GateCandlestick {
  t?: number | string;
  o?: string;
  h?: string;
  l?: string;
  c?: string;
  v?: number | string;
}

const GATE_CANDLES_URL =
  "https://api.gateio.ws/api/v4/futures/usdt/candlesticks";

export const gateCandlesRestAdapter: ExchangeCandleRestAdapter = {
  async fetchCandles(params: CandleFetchParams): Promise<CandlePoint[]> {
    const contract = normalizeCandleSymbol("gate", params.symbol);
    const query = new URLSearchParams({
      contract,
      interval: toGateInterval(params.interval),
    });
    if (params.startTime) {
      query.set("from", String(Math.floor(params.startTime / 1000)));
    }
    if (params.endTime) {
      query.set("to", String(Math.floor(params.endTime / 1000)));
    }

    const response = await fetch(`${GATE_CANDLES_URL}?${query.toString()}`);
    if (!response.ok) {
      throw new Error("Price chart is temporarily unavailable");
    }

    const payload = (await response.json()) as GateCandlestick[];
    if (!Array.isArray(payload)) return [];

    return dedupeCandles(
      payload.map((kline) => ({
        startTime: Number(kline.t ?? 0) * 1000,
        openPrice: kline.o ?? "0",
        highPrice: kline.h ?? "0",
        lowPrice: kline.l ?? "0",
        closePrice: kline.c ?? "0",
        volume: String(kline.v ?? "0"),
      }))
    );
  },
};
